<template>
  <div :class="'profile-summary'">
    <!--each(item in detailRightTop)-->
    <div
      v-for="(item, index) in detailRightTop"
      v-bind:key="index + 1"
      :class="'row summary-item ' + (item.parentClass ? item.parentClass : '')"
    >
      <div :class="'col-md-12'">
        <div :class="'item ' + (item.className ? item.className : '')">
          <!--if(item.type!='no-icon' && item.icon)-->
          <span v-if="item.type != 'no-icon' && item.icon">
            <i :class="'material-symbols-outlined'">{{ item.icon }}</i>
          </span>
          <!--endif-->

          <div>
            <!--if(item.label)-->
            <span
              v-if="item.label"
              :class="'item-label ' + (item.labelClass ? item.labelClass : '')"
              >{{ item.label }}</span
            >
            <!--endif-->
            <div v-if="item.content">
              <a
                :href="item.content"
                v-if="item.type == 'image'"
                target="_blank"
              >
                <img :src="item.content" alt="" />
              </a>
              <a
                :href="item.content"
                target="_blank"
                v-else-if="item.type == 'file'"
              >
                Download File
              </a>
              <h5
                v-else
                :class="'item-content'"
                v-html="
                  item.content && item.content != null && item.content != 'null'
                    ? item.content
                    : 'Tidak Ada'
                "
                style="white-space: pre-wrap"
              >
                <!-- {{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }} -->
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--endeach-->
    <!--if(detailRightBottom && detailRightBottom.length)-->
    <!--each(item in detailRightBottom)-->
    <div v-if="detailRightBottom && detailRightBottom.length">
      <div
        v-for="(item, index) in detailRightBottom"
        v-bind:key="index + 1"
        :class="
          'row summary-item ' + (item.parentClass ? item.parentClass : '')
        "
      >
        <div :class="'col-md-12'">
          <div :class="'item mb-3'">
            <!--if(item.type!='no-icon' && item.icon)-->
            <span v-if="item.type != 'no-icon' && item.icon">
              <i :class="'material-symbols-outlined'">{{ item.icon }}</i>
            </span>
            <!--endif-->
            <div v-if="item.content">
              <!--if(item.content)-->
              <h5 :class="'item-content'">
                {{
                  item.content && item.content != null && item.content != "null"
                    ? item.content
                    : "Tidak Ada"
                }}
              </h5>
              <!--endif-->
            </div>
          </div>
          <router-link
            :class="'btn btn-block ' + item.className"
            :to="item.link"
          >
            <!--if(item.leftIcon)-->
            <i v-if="item.leftIcon" :class="'material-symbols-outlined'">{{
              item.leftIcon
            }}</i>
            <!--endif-->
            {{ item.label }}
            <!--if(item.rightIcon)-->
            <i v-if="item.rightIcon" :class="'material-symbols-outlined'">{{
              item.rightIcon
            }}</i>
            <!--endif-->
          </router-link>
        </div>
      </div>
    </div>
    <!--endeach-->
    <!--endif-->
    <!--if(detailApproval)-->
    <form v-if="detailApproval" :action="detailApproval.actionApprove">
      <div
        :class="
          'row summary-item ' +
          (detailApproval.parentClass ? detailApproval.parentClass : '')
        "
      >
        <div :class="'col-md-12'">
          <!--if(detailApproval.approvedDays)-->
          <div
            v-if="detailApproval.approvedDays"
            :class="'row form-group form-inline'"
          >
            <label :class="'col-md-6 mb-0'">{{
              detailApproval.approvedDays.label
            }}</label>
            <div :class="'input-group col-md-6'">
              <input
                type="number"
                :class="'form-control'"
                :value="detailApproval.approvedDays.value"
                max=""
                min=""
                required=""
                step=""
                pattern="[0-9]*"
                :name="detailApproval.approvedDays.name"
              />
              <div :class="'input-group-append'">
                <span :class="'input-group-text'">day(s)</span>
              </div>
            </div>
          </div>
          <!--endif-->
          <div :class="'form-group '">
            <label>
              {{ detailApproval.label }}
            </label>
            <!--if(detailApproval.name)-->
            <div v-if="detailApproval.name">
              <textarea
                rows="4"
                :class="'form-control'"
                :placeholder="detailApproval.placeholder"
                :name="detailApproval.name"
                v-model="detailApproval.value"
              >
{</textarea
              >
            </div>
            <!--endif-->
          </div>
          <div :class="'row'">
            <!--if(detailApproval.actionReject)-->
            <div v-if="detailApproval.Reject" :class="'col-md-4'">
              <!--if(detailApproval.type=='form')-->
              <button
                v-if="detailApproval.type == 'form'"
                type="submit"
                :formaction="detailApproval.actionReject"
                :class="'btn btn-block btn-outline-danger btn-no-outline'"
              >
                {{ detailApproval.labelReject }}
              </button>
              <!--else-->
              <router-link
                v-else
                :to="detailApproval.actionReject"
                :class="'btn btn-block btn-outline-danger btn-no-outline'"
              >
                {{ detailApproval.labelReject }}
              </router-link>
              <!--endif-->
            </div>
            <!--endif-->
            <!--if(detailApproval.actionReject)-->
            <div
              :class="detailApproval.actionReject ? 'col-md-8' : 'col-md-12'"
            >
              <!--endif-->
              <!--if(detailApproval.type=='form')-->
              <button
                v-if="detailApproval.type == 'form'"
                type="submit"
                :class="'btn btn-block btn-primary btn-with-icon-left'"
              >
                <i :class="'material-symbols-outlined'">check</i>
                {{ detailApproval.labelApprove }}
              </button>
              <!--else-->
              <router-link
                v-else
                :to="detailApproval.actionApprove"
                :class="'btn btn-block btn-primary btn-with-icon-left'"
              >
                <i :class="'material-symbols-outlined'">verified_user</i>
                {{ detailApproval.labelApprove }}
              </router-link>
              <!--endif-->
            </div>
          </div>
        </div>
      </div>
    </form>
    <!--endif-->
    <!--if(nav && nav.length)-->
    <!--each(item in nav)-->
    <div
      v-for="item in nav"
      v-bind:key="item.label"
      :class="'row summary-item no-border ' + item.parentClass"
    >
      <div :class="'col-md-12'">
        <!--if(item.type=='modal')-->
        <router-link
          v-if="item.type == 'modal'"
          data-toggle="modal"
          :data-target="item.link"
          :class="'btn ' + item.className"
        >
        </router-link>
        <!--else-->
        <router-link v-else :to="item.link" :class="'btn ' + item.className">
          <!--endif-->
          <!--if(item.iconLeft)-->
          <i v-if="item.iconLeft" :class="'material-symbols-outlined'">{{
            item.iconLeft
          }}</i>
          <!--endif-->
          {{ item.label }}
          <!--if(item.iconRight)-->
          <i v-if="item.iconRight" :class="'material-symbols-outlined'">{{
            item.iconRight
          }}</i>
          <!--endif-->
        </router-link>
      </div>
    </div>
    <!--endeach-->
    <!--endif-->
  </div>
</template>
<style scoped>
img {
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
}
</style>
<script>
export default {
  name: "DetailRight",
  props: {
    detailRightTop: Array,
    detailRightBottom: Array,
    detailApproval: Object,
    nav: Array,
  },
};
</script>